export function initMoreButton() {
  const moreButtons = document.querySelectorAll('.js-more-button');
  if (moreButtons.length === 0) return;

  moreButtons.forEach((moreButton) => {
    moreButton.addEventListener('click', () => {
      moreButton.remove();
    });
  });
}
